import { Card, CardContent, Typography, Button, Stack } from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function RetentionActions() {
  return (
    <CustomCard >
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Actions recommandées
        </Typography>

        <Stack spacing={2}>
          <Button variant="outlined">
            🎁 Offrir un billet promo aux VIP
          </Button>
          <Button variant="outlined">
            🔔 Relancer les inactifs (60j)
          </Button>
          <Button variant="outlined">
            📣 Créer une campagne fidélité
          </Button>
        </Stack>
      </CardContent>
    </CustomCard>
  );
}
